import { render, staticRenderFns } from "./MobileServer.vue?vue&type=template&id=1a767792&scoped=true&"
import script from "./MobileServer.vue?vue&type=script&lang=js&"
export * from "./MobileServer.vue?vue&type=script&lang=js&"
import style0 from "./MobileServer.vue?vue&type=style&index=0&id=1a767792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a767792",
  null
  
)

export default component.exports